import React, { Component } from 'react'
import {Chart, registerables} from "chart.js";

import "./LineGraph.css";

export default class PieChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rerender: 0
    }
    this.pieChart = undefined;
    this.lastLabel = null;
    this.labelLength = 0;
    this.scale = props.zoom ? props.zoom : 1;
    this.chartRef = React.createRef();
  }
 
  componentDidMount() {
    Chart.register(...registerables);
    this.buildChart(this.props.units)
    if (this.pieChart)
      this.setState({rerender: this.state.rerender+1})
  }

  componentDidUpdate() {
    this.scale = this.props.zoom ? this.props.zoom : this.scale;
    this.buildChart(this.props.units);
  }
  componentWillUnmount(){
    if (typeof this.pieChart !== "undefined")
      this.pieChart.destroy();
  }
  distinctUnits (arrData) {
    return arrData.filter((x, index, self) => self.findIndex(y => y?.units1 === x?.units1) === index)
  }

  buildChart = (units) => {
    const myChartRef = this.chartRef.current.getContext("2d");
    const chartObj = this.chartObjCommon('pie');
    if (typeof this.pieChart !== "undefined") this.pieChart.destroy();
    this.pieChart = new Chart(myChartRef, chartObj);
  }
  getColors(length) {
    const palette = ['#009faa', '#1a237e', '#37b0a9', '#003d94', '#6bc0aa', '#0053a2', '#95cfaf', '#0068aa',
    '#badeb9', '#007bad', '#dcedc8', '#008dac', ];
    let colors = [];

    for(let i = 0; i < length; i++) {
      colors.push(palette[i % palette.length]);
    }
    return colors;
  }
  chartObjCommon(kind) {
    const chartNumbers = this.props?.data ?? [];
    const thisLegend = this.props?.legend ?? {display: false}
    const colors = this.getColors(chartNumbers.length);
    const labels = this.props?.labels ?? [];
    const animationTime = 500;
    const chartObj = {
    type: kind,
    borderWidth: 0,
    data: {
        labels: labels,
        datasets: [{
          label: labels,  //
          data: chartNumbers,
          backgroundColor: colors,
        }],
    },
    options: {
        plugins: {
          legend: thisLegend,
          tooltip: {
            callbacks: {
            label: function(context) {
              return context?.dataset?.label[context.dataIndex] + ' : ' + context.formattedValue
            },
            }
          }  
        },
        responsive: true,
        maintainAspectRatio: false,
        animation: { duration: animationTime },     // general animation time 
        hover: { animationDuration: animationTime }, // hover animation time
        responsiveAnimationDuration: animationTime,  // animation duration after a resize 
        elements: {
        arc: {
            borderWidth: 0
        }
        },
    } 
    }
    return chartObj;
  }

  render() {
    return (<canvas id="pChart" ref={this.chartRef} />)
  }
}
